export default "__VITE_ASSET__88dcc19c__"